import React, { FC } from 'react'
import FbImageLibrary from '../../../FbImageLibrary'

import TwitterComment from '../../../UI/Icons/TwitterComment'
import TwitterLike from '../../../UI/Icons/TwitterLike'
import TwitterReply from '../../../UI/Icons/TwitterReply'
import TwitterUpload from '../../../UI/Icons/TwitterUplaod'
import MessageFieldWithExtra from '../../PostEditor/UI/MessageField'

import { TPostSocialManagePost } from '../../../../store/managePost/newTypes'
import { SOCIAL_NETWORK } from '../../../../models/post'
import { TSocialDetails } from '../../../../selectors/ProjectSelector'

import './TwitterPreview.scss'
import VideoPreview from '../../../UI/VideoPreview'
import LoadableImage from '../../../UI/LoadableImage'

interface TwitterPreviewProps {
  isMokup?: boolean
  socialPost: TPostSocialManagePost
  isMobile?: boolean
  restrictions: any
  socialDetails: TSocialDetails
  publishDate: string
}

const LinkedinPreview: FC<TwitterPreviewProps> = ({
  isMokup,
  socialPost,
  restrictions,
  publishDate,
  isMobile,
  socialDetails
}) => {
  return (
    <div
      className={`post-preview twitter-preview ${isMokup && 'mokup'} ${isMobile && 'mobile-view'}`}
    >
      <div className='twitter-preview__header'>
        <div className='twitter-preview__header__avatar'>
          {socialDetails[SOCIAL_NETWORK.TWITTER_SOCIAL].logo.original ? (
            <LoadableImage media={socialDetails[SOCIAL_NETWORK.TWITTER_SOCIAL].logo.original!} />
          ) : (
            socialDetails[SOCIAL_NETWORK.TWITTER_SOCIAL]!.logo.default
          )}
        </div>
        <div className='twitter-preview__header__post-meta twitter-post-data'>
          <div className='twitter-post-data__customer-data'>
            <div className='twitter-post-data__customer-data__name'>
              {socialDetails[SOCIAL_NETWORK.TWITTER_SOCIAL]!.name}
            </div>
            <div className='twitter-post-data__customer-data__login-and-date'>
              {publishDate}
            </div>
            <div className='twitter-post-data__customer-data__arrow-down' />
          </div>
        </div>
      </div>
      {(restrictions.mediaRestrictions.image || restrictions.mediaRestrictions.video) &&
        !!socialPost.attachments.length && (
          <div className='twitter-preview__body twitter-preview-left-margin '>
            <div className='twitter-preview__body__attachments'>
              {restrictions.mediaRestrictions.image ? (
                <FbImageLibrary
                  hideOverlay={true}
                  images={socialPost.attachments
                    .filter(({ object_data }) => !!object_data)
                    .map(({ object_data }) => object_data!)}
                  isEditable={false}
                />
              ) : (
                <VideoPreview
                  attachment={socialPost.attachments[0]}
                  width={isMokup ? 125 : 300}
                  className='twitter-preview__body__attachments__video'
                />
              )}
            </div>
          </div>
        )}
      <div className='twitter-preview__body__message twitter-preview-left-margin'>
        {socialPost.message && (
          <MessageFieldWithExtra
            {...{
              social: socialPost.social_network,
              editorRaws: socialPost.message_editor_state,
              value: socialPost.message
            }}
          />
        )}
      </div>
      <div className='twitter-preview__reaction twitter-preview-left-margin'>
        <div className='twitter-preview__reaction__item'>
          <TwitterComment />
        </div>
        <div className='twitter-preview__reaction__item'>
          <TwitterReply />
        </div>
        <div className='twitter-preview__reaction__item'>
          <TwitterLike />
        </div>
        <div className='twitter-preview__reaction__item'>
          <TwitterUpload />
        </div>
      </div>
    </div>
  )
}

export default LinkedinPreview
